import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import CLP from './CLP'
import FreeCodeCamp from './FreeCodeCamp'
import MainContent from './MainContent'
import Portfolio from './Portfolio'
import Responsive from './Responsive'
import db from '../DataSource/Firebase'
import { educationData,QualificationData,projectData,SkillData,coursesData } from "../DataSource/Data";
import { useDispatch, useSelector } from "react-redux"
import { setCoursesData, setEduData, setExpData, setHobbies, setProfileData, setProjectsData, setSkillsData } from '../store/actions'
import Header from './Header'
import { CirclesWithBar, InfinitySpin, LineWave } from 'react-loader-spinner'

let arr = [];


 const HomeNew = () => {
  const dipatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  let arrExp = [];
  let arrEdu = [];
  let arrProjects = [];
  let skills = [];
  let courses = [];
  let profile = [];
  let hobbies = [];


  useEffect(()=>{
    // db.collection("hobby").doc('2weather').set(	  {
    //   id:2,
    //   projectName: 'Weather & Air Pollution Monitor',
    //   img: 'https://play-lh.googleusercontent.com/vRiLxccOtrzbonEBTmXO3tiRukteDLx9l-CRVijIzqtaCjGZEdIbnFG10HTW3H8VSl_s=w832-h470-rw',
    //   description:"Designed, developed & published this app that lets you monitor weather and air pollution conditions of any location in the world. Check Current Weather, 7-Day Forecast and Air Pollution In your Location.",
    //   tech: ['Android', 'Java', 'Rest API','Retrofit','Jetpack'],
    //   link:'https://play.google.com/store/apps/details?id=com.yogdroidtech.weatherapp'
  
    // });
    getData('experience');
    getData('education');
    getData('projects');
    getData('skills');
    getData('courses');
    getData('profileData');
    getData('hobby');
    
  
  

  },[])

  const getData = (dataType)=>{
    db.collection(dataType).get().then((querySnapshot) => {
      setLoading(false);
      querySnapshot.forEach((doc) => {
          console.log(doc.id, " => ", doc.data());
          switch(dataType){
            case 'experience':
              arrExp.push(doc.data())
              break;
            case 'education':
              arrEdu.push(doc.data())
              break;
            case 'projects':
              arrProjects.push(doc.data())
              break;
            case 'skills':
              skills.push(doc.data())
              break;  
            case 'courses':
              courses.push(doc.data())
              break;       
            case 'profileData':
              profile.push(doc.data())
              break;  
            case 'hobby':
              hobbies.push(doc.data())
              break;         
          }
          
      });
      switch(dataType){
        case 'experience':
          // alert('exp');
          dipatch(setExpData(arrExp));
          break;
        case 'education':
          // alert('edu');
            dipatch(setEduData(arrEdu));
         break;
        case 'projects':
          dipatch(setProjectsData(arrProjects));
        break;
        case 'skills':
          dipatch(setSkillsData(skills));
        break;
        case 'courses':
          dipatch(setCoursesData(courses));
        break;
        case 'profileData':
          dipatch(setProfileData(profile));
        break;
        case 'hobby':
          dipatch(setHobbies(hobbies));
        break;
      }
  
  }).catch((e)=>{
    setLoading(false)
      alert(e)
    });
  }

  
  return (
    <MainWrapper>
      {/* <Header/> */}
      {
        isLoading ?   
        <div className='loader'>
    <InfinitySpin sty color="#2B86C5" width="150" loading={true} /> 
        </div>
    
        :   <Portfolio />
      }
    
    
      {/* <Responsive/> */}
      {/* <FreeCodeCamp/> */}
      {/* <MainContent/> */}
    </MainWrapper>
  );
}

const MainWrapper = styled.section`
  width: 100%;
  .loader {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }

  /* background-color: aqua; */
  /* display: flex;
justify-content: center;
align-items: center; */
  /* margin: 3rem; */
`;

export default HomeNew
